module.exports = __webpack_public_path__ + "static/img/banner_1027.c9a81b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/image/banner_1027.png
// module id = vDf8
// module chunks = 0